import { Service } from "typedi";
import { Repository } from "./repository";
import { Favorite } from "./models/favorite.model";

@Service()
export class FavoriteRepository extends Repository<Array<Favorite>> {
    clazz = Favorite
    key = "favorites"
}
